import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['container']

  connect() {
    this.toggle()
  }

  toggle() {
    const checked = this.element.querySelector("input[type=checkbox][name$='[always_cc]']").checked
    const hidden = !checked

    this.containerTarget.classList.toggle('hidden', hidden)
    this.containerTarget
      .querySelectorAll('input, select, textarea, button')
      .forEach((field) => {
        field.disabled = hidden
      })
  }
}
